import React from 'react';
import PropTypes from 'prop-types';

const IosArrowRight = ({ color = '#C70000', width = 7, height = 14 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="14" viewBox="0 0 7 14" fill="none">
    <path d="M1 12.5795L5.59317 7.98628C6.13561 7.44384 6.13561 6.5562 5.59317 6.01376L1 1.42059" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

IosArrowRight.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default IosArrowRight; 